import { jsx as _jsx } from "react/jsx-runtime";
const MenuItems = ({ menuItems }) => {
    return (_jsx("ul", { className: "header__main-menu-list", children: menuItems.map((menuItem, i) => (_jsx("li", { className: "header__main-menu-item", children: _jsx("a", { className: "header__main-menu-link", href: menuItem.url, children: menuItem.title }) }, i))) }));
};
export default MenuItems;
